import { ParentWebsite } from '../types';

export const getParentWebsite = (): ParentWebsite => {
  return window.location.href.includes('west-midlands')
    ? 'west-midlands'
    : 'coventry';
};
